import './styles/ActionModal.css'
import { useState,useEffect } from 'react';
import Action from './Action'
import Modal from 'react-modal';
import Selector from './Selector'
import InputForm from './InputForm';
import LoadAdding from './LoadAdding';
import { useFetch } from '../hooks/useFetch'
const ResetModal = ({setResponseData,mode,byHost,techType,isOpen,ip,handleShowPopup, data,statusPing,closeActionModal ,server}) => {
  const host=data.length===1?data[0]:data[1]
  const [dataPing,setDataPing]=useState({data:[],loading:false,error:null})
  const [ejecuta,setEjecuta]=useState(false)
  const test={
    "message": "Se recupero al menos un dispositivo del PMI",
    "success": true,
    "data": {
      "pmiStatusInicialMessage": "Todos los dispositivos del pmi comenzaron en estado mixto up/down conectados/desconectados",
      "action": true,
      "pmiDetalleRecuperacion": "Se recupero al menos un dispositivo del PMI",
      "status_detail": [
        {
          "index": 0,
          "hostid": 11545,
          "host": "SUSCRIPTOR-RADWIN-CHIH01-VVU-CDJU-204-JUAREZ-NIM-03",
          "alias": "CHIH01-VVU-CDJU-204",
          "name": "",
          "device_id": 11,
          "ip": "10.169.8.115",
          "b_interes": 1,
          "b_ubicacion": 1,
          "capa": 1,
          "tech_name": "SUSCRIPTORES",
          "statusInicial": true,
          "statusIntermedio": true,
          "statusFinal": true
        },
        {
          "index": 2,
          "hostid": 11546,
          "host": "SWITCH-VVU-MOXA-CHIH01-VVU-CDJU-204",
          "alias": "CHIH01-VVU-CDJU-204",
          "name": "",
          "device_id": 13,
          "ip": "10.169.8.116",
          "b_interes": 1,
          "b_ubicacion": 1,
          "capa": 1,
          "tech_name": "SWITCH PMI",
          "statusInicial": true,
          "statusIntermedio": true,
          "statusFinal": true
        },
        {
          "index": 4,
          "hostid": 11547,
          "host": "PTZ-VVU-TKH-CHIH01-VVU-CDJU-204",
          "alias": "CHIH01-VVU-CDJU-204",
          "name": "",
          "device_id": 8,
          "ip": "10.169.26.202",
          "b_interes": 1,
          "b_ubicacion": 1,
          "capa": 1,
          "tech_name": "PTZ",
          "statusInicial": true,
          "statusIntermedio": true,
          "statusFinal": true
        },
        {
          "index": 6,
          "hostid": 11548,
          "host": "F1-VVU-Siqura-CHIH01-VVU-CDJU-204",
          "alias": "CHIH01-VVU-CDJU-204",
          "name": "",
          "device_id": 4,
          "ip": "10.169.26.203",
          "b_interes": 1,
          "b_ubicacion": 1,
          "capa": 1,
          "tech_name": "FIJAS",
          "statusInicial": true,
          "statusIntermedio": true,
          "statusFinal": true
        },
        {
          "index": 8,
          "hostid": 11549,
          "host": "F2-VVU-Siqura-CHIH01-VVU-CDJU-204",
          "alias": "CHIH01-VVU-CDJU-204",
          "name": "",
          "device_id": 4,
          "ip": "10.169.26.213",
          "b_interes": 1,
          "b_ubicacion": 1,
          "capa": 1,
          "tech_name": "FIJAS",
          "statusInicial": true,
          "statusIntermedio": false,
          "statusFinal": true
        },
        {
          "index": 10,
          "hostid": 22456,
          "host": "RESET-KING_PIGEON-S475-CHIH01-VVU-CDJU-204",
          "alias": "CHIH01-VVU-CDJU-204",
          "name": "",
          "device_id": 26,
          "ip": "10.169.50.171",
          "b_interes": 1,
          "b_ubicacion": 0,
          "capa": 1,
          "tech_name": "RESET",
          "statusInicial": false,
          "statusIntermedio": false,
          "statusFinal": false
        },
        {
          "index": 12,
          "hostid": 23362,
          "host": "LPR1-VVU-AXIS-P1465-LE-CHIH01-VVU-CDJU-204",
          "alias": "CHIH01-VVU-CDJU-204",
          "name": "",
          "device_id": 1,
          "ip": "10.169.26.21",
          "b_interes": 1,
          "b_ubicacion": 1,
          "capa": 1,
          "tech_name": "LPR",
          "statusInicial": true,
          "statusIntermedio": true,
          "statusFinal": true
        }
      ]
    },
    "status_code": 200
  }
  const testng=()=>{
    setDataPing({data:test,loading:false,error:null})
    setResponseData({active:true,data:test})
  }
  const Ejecutar=()=>{
    // setTimeout(testng,2000)
    setEjecuta(true)
    const obj={
      affiliation:data.affiliation,
      hostid:data.hostid
    }
    let method='POST'
    // let url=(byHost)?'reset_pmi/by_device/'+techType.id+'?affiliation='+data.affiliation:'reset_pmi?affiliation='+data.affiliation
    // setLoading(true)
    let url = 'resets/reset/request/'+techType.id+'?affiliation='+data.affiliation
    setDataPing({data:dataPing.data,loading:true,error:null})
    const fetchDataPost = async () => {
      
   try {
     // console.log(localStorage.getItem('access_token'))
     // const response = await fetch(server.url+'/api/v1/cassia/resets/reset_pmi?affiliation='+data.affiliation, {
     const response = await fetch(server.url+'/api/v1/cassia/'+url, {
     // const response = await fetch(server.url+'/api/v1/zabbix/hosts/actionz/'+ip+'/-1', {
     method: method,  
     headers: {
         'Content-Type': 'application/json',
         Authorization: `Bearer ${localStorage.getItem('access_token')}`,
       },
       // body:JSON.stringify(obj)
    
   });
     if (response.ok) {
       const data1 = await response.json();
       setDataPing(data1)
       // if(!isOpen){
       handleShowPopup(
         ((data1.success)?'Completado':'Error!!!'),
         (data1.success?' '+data1.message+' al dispositivo "'+data.affiliation+'" ':
         ' RESET al dispositivo "'+data.affiliation+'" ejecutada sin exitó'),
         (data1.success)?'':data1.message, 
         data1.success
       )
       // }
       setDataPing({data:data1,loading:false,error:null})
       setResponseData({active:true,data:data1})
     } else {
       setDataPing({data:dataPing.data,loading:false,error:null})
       throw new Error('Error en la solicitud');
     }
   } catch (error) {
        setDataPing({data:dataPing.data,loading:false,error:null})
        console.error(error);
        
        handleShowPopup('Error!!!','  RESET al dispositivo "'+data.affiliation+'" ejecutada sin exitó','Favor de reportar el error', false)
        
      }
    };

    fetchDataPost();
  }
  return (
    <>
      <div className={'contActionModal'+mode}>
          <div className='titlePinglModal'>
          <div className='actionsTitle'>
                  <div className='textCardTitle' style={{color:(mode==''?'var(--main-color)':'var(--white-color)')}}>
                           Ejecutar Accion:
                            </div>
                            
                  </div>
                  <hr className={'lineTitlePing'+mode}></hr>
          </div>
          <div className='contAnimationActionModal'>
             
              <div className='contAnimation' style={{width:'60%',textAlign:'center'}}>

                  {
                      (ejecuta==false)?<p className={'msgErrorPing '} >
                      {/* (false)?<p className={'msgErrorPing '} > */}
                      {'Desea ejecutar la accion RESET '+((byHost)?'para '+techType.label:'')+' ?'}
                 </p>:
                     <>
                     { dataPing.loading===true?<section className="dots-container-action">
                     {/* { true?<section className="dots-container"> */}
                      <div className="dots-action" style={{height:'15px'}}></div>
                      <div className="dots-action" style={{height:'15px'}}></div>
                      <div className="dots-action" style={{height:'15px'}}></div>
                      <div className="dots-action" style={{height:'15px'}}></div>
                      <div className="dots-action" style={{height:'15px'}}></div>
                      <div className="dots-action" style={{height:'15px'}}></div>
                      <div className="dots-action" style={{height:'15px'}}></div>
                      <div className="dots-action" style={{height:'15px'}}></div>
                  </section>:(dataPing.data.length!=0)?
                  <p className={( dataPing.data.success )?'msgPing':'msgErrorPing '} >
                       {(dataPing.data.success )?' '+dataPing.data.message+' al dispositivo "'+data.affiliation+'" ':' RESET ejecutada sin exitó'}
                  </p>:<p className={'msgErrorPing '} >
                       {'Ocurrio un error y no pudo ejecutarce la accion!!!'}
                  </p>}
                     </>
                  }
              
              
              </div>
              {/* <div className=' constImg contSecondImg'>
              <div className='divImgPing'>
                  <img src="router_1.png"  className='icon-ping' alt="Logo"/>
                  </div>
                  <div className='divtextPing'>
                  {data.name_hostipC}
                  </div>
              </div> */}
          </div>
          <div className='contActionsActionModal'>
          <div className='menuActionData' style={{display:'flex'}}>
                        {(ejecuta==false)?<div className='menuActionCell' style={{border: 'unset',width:'25%'}}>
                            <Action origen='Azul' disabled={false} titulo={'Ejecutar'} action={Ejecutar} />
                        </div>:''}
                        <div className='menuActionCell' style={{border: 'unset',width:'25%'}}>
                            <Action origen='Cancelar' disabled={false} titulo={'Salir'} action={closeActionModal} />
                        </div>
                        </div>
          </div>
      </div>
           
</>
  );
};

  export default ResetModal